import React from 'react';
import PropTypes from 'prop-types'

import { db } from '../../firebase';

import { Form, Button, Segment } from 'semantic-ui-react'

class SearchPhoneForm extends React.Component {
  state = {
    //Form
    isSubmitting: false,
    number: '',
 }

 onSubmit = event => {
   event.preventDefault();

   this.setState({ isSubmitting: true })
   const { number } = this.state
   db.onceGetPhoneLocations(number)
     .then(snapshot => {
       this.setState(() => ({
         isSubmitting: false,
       }))
       this.props.onLocationsFound(snapshot.val(), number)
     })
     .catch(error => {
       console.log(error);
     });
 }

  render() {
    const {
      isSubmitting
    } = this.state;

    return (
      <Segment loading={isSubmitting}>
        <Form inline onSubmit={this.onSubmit}>
            <Form.Input
              label="Search Phone Number"
              value={this.state.number}
              onChange={event => this.setState({number: event.target.value})}
            />
            <Button>Search</Button>
        </Form>
      </Segment>
    )
  }

  static propTypes = {
    onLocationsFound: PropTypes.func.isRequired,
  }
}

export default SearchPhoneForm;



// WEBPACK FOOTER //
// ./src/components/Phone/SearchPhoneForm.js